import React from 'react';
import HelpHead from './helpHead';
import HelpStack from './helpStack';
import HelpArticles from './helpArticles';
import HelpActivity from './helpActivity';

export default function HelpCenter() {
  return (
    <>
      <HelpHead />
      <HelpStack />
      <HelpArticles />
      <HelpActivity />
    </>
  )
}
